import {
	UNDECLARED_DELAY_BG,
	UNDECLARED_DELAY_HOVER_BG,
} from "@/shared/colors";
import { SxProps, Theme } from "@mui/material";
import { RowClassParams } from "ag-grid-community";

interface DelayRow {
	DelayCodeId: number | null;
	DelayCategoryId: number | null;
}

export const UNDECLARED_DELAY_ROW_CLASS = "undeclared-delay-row";

export const getUndeclaredDelayRowClass = <T extends DelayRow>(
	params: RowClassParams<T>,
): string | undefined => {
	if (
		params.data &&
		params.data.DelayCodeId == null &&
		params.data.DelayCategoryId == null
	) {
		return UNDECLARED_DELAY_ROW_CLASS;
	}
	return undefined;
};

export const undeclaredDelayRowStyles: SxProps<Theme> = {
	[`& .${UNDECLARED_DELAY_ROW_CLASS}`]: {
		backgroundColor: UNDECLARED_DELAY_BG,
	},
	[`& .${UNDECLARED_DELAY_ROW_CLASS}:hover`]: {
		backgroundColor: `${UNDECLARED_DELAY_HOVER_BG} !important`,
	},
	[`& .${UNDECLARED_DELAY_ROW_CLASS}.ag-row-selected`]: {
		backgroundColor: UNDECLARED_DELAY_HOVER_BG,
	},
};
